import { c as _c } from "react/compiler-runtime";
import IconCrownRound from '@/components/assets/icon_crown_round.svg';
import IconUserRound from '@/components/assets/icon_user_round.svg';
import ViverseAvatar from '@/components/ViverseAvatar';
import { cn } from '@/lib/utils';
import { Comment } from '@/types/comments';
import { useTranslations } from 'next-intl';
import { ReactNode, useMemo } from 'react';
function formatTimeAgo(timeString: string) {
  const unixTime = Date.parse(timeString);
  if (typeof unixTime === 'number') {
    const ts = unixTime < 1e12 ? unixTime * 1000 : unixTime;
    const diff = Date.now() - ts;
    const MIN = 60_000,
      HOUR = 3_600_000,
      DAY = 86_400_000,
      WEEK = 7 * DAY,
      YEAR = 365 * DAY,
      MONTH = YEAR / 12;
    const table = [{
      limit: MIN,
      unit: null,
      unitKey: 'now'
    }, {
      limit: HOUR,
      unit: MIN,
      unitKey: 'minute'
    }, {
      limit: DAY,
      unit: HOUR,
      unitKey: 'hour'
    }, {
      limit: WEEK,
      unit: DAY,
      unitKey: 'day'
    }, {
      limit: 4 * WEEK,
      unit: WEEK,
      unitKey: 'week'
    }, {
      limit: YEAR,
      unit: MONTH,
      unitKey: 'month'
    }, {
      limit: Infinity,
      unit: YEAR,
      unitKey: 'year'
    }];
    for (const row of table) {
      if (diff < row.limit) {
        return {
          time: `${row.unit ? Math.floor(diff / row.unit) : ''}`,
          unitKey: row.unitKey
        };
      }
    }
  }
  return {
    time: '',
    unitKey: ''
  };
}
interface CommentTitleProps {
  children?: ReactNode;
  isTablet?: boolean;
  isRemoved?: boolean;
  isYou?: boolean;
  isCreator?: boolean;
  comment: Comment;
}
function CommentTitle(t0) {
  const $ = _c(39);
  const {
    children,
    isTablet,
    isRemoved: t1,
    isYou,
    isCreator,
    comment
  } = t0;
  const isRemoved = t1 === undefined ? false : t1;
  const t = useTranslations();
  let t2;
  if ($[0] !== comment.date_created) {
    t2 = formatTimeAgo(comment.date_created);
    $[0] = comment.date_created;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const commentTimeAgo = t2;
  let t3;
  if ($[2] !== commentTimeAgo.time || $[3] !== commentTimeAgo.unitKey || $[4] !== t) {
    t3 = () => {
      const timeValue = commentTimeAgo.time;
      const timeUnit = t(`comment-title.time-unit.${commentTimeAgo.unitKey}`);
      const ageSuffix = commentTimeAgo.unitKey === "now" ? "" : t("comment-title.age");
      return `${timeValue}${timeUnit} ${ageSuffix}`.trim();
    };
    $[2] = commentTimeAgo.time;
    $[3] = commentTimeAgo.unitKey;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const renderTimeDisplay = t3;
  const showRole = !isRemoved && (isYou || isCreator);
  const t4 = isTablet ? "M" : "S";
  const t5 = isRemoved ? "" : comment.owner.head_icon_url;
  const t6 = isRemoved ? undefined : comment.owner.display_name;
  let t7;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = <ViverseAvatar size={t4} imageUrl={t5} name={t6} />;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== comment.owner || $[11] !== isRemoved || $[12] !== t) {
    t8 = isRemoved ? t("comment-title.deleted") : `@${comment.owner.display_name}`;
    $[10] = comment.owner;
    $[11] = isRemoved;
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <span className="subheader4-omni-styles text-vive-primary-20">{t8}</span>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== renderTimeDisplay) {
    t10 = renderTimeDisplay();
    $[16] = renderTimeDisplay;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <span className="text-vive-primary-40 text-xs leading-4 font-normal tracking-[0.15px]">{t10}</span>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== isYou || $[21] !== showRole || $[22] !== t) {
    t12 = showRole && <div className="flex items-center gap-0.5 opacity-70 lg:gap-1"><span className="text-vive-primary-40 text-xs leading-4">•</span><span className={cn("text-xs leading-4 font-normal tracking-[0.15px]", isYou ? "text-[#33d5c5]" : "text-[#ff82fb]")}>{isYou ? t("comment-title.role.you") : t("comment-title.role.creator")}</span>{isYou ? <IconUserRound className="size-3 fill-[#33D5C5]" /> : <IconCrownRound className="size-3 fill-[#FF82FB]" />}</div>;
    $[20] = isYou;
    $[21] = showRole;
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== children || $[25] !== isRemoved || $[26] !== showRole) {
    t13 = !isRemoved && <div className={!showRole ? "ml-auto" : undefined}>{children}</div>;
    $[24] = children;
    $[25] = isRemoved;
    $[26] = showRole;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t11 || $[29] !== t12 || $[30] !== t13 || $[31] !== t9) {
    t14 = <div className="flex flex-1 items-center gap-1 md:gap-2">{t9}{t11}{t12}{t13}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
    $[31] = t9;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== isRemoved) {
    t15 = isRemoved && <div />;
    $[33] = isRemoved;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t14 || $[36] !== t15 || $[37] !== t7) {
    t16 = <div className="mb-2 flex h-8.5 w-full gap-2 md:mb-0 md:gap-4">{t7}{t14}{t15}</div>;
    $[35] = t14;
    $[36] = t15;
    $[37] = t7;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}
export default CommentTitle;